import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatarNumeroBR'
})
export class NumberUtil implements PipeTransform {
    transform(value: number): string {
        return value.toLocaleString('pt-BR');
    }

    static converterMinutosEmMilissegundos(minutos: number): number {
        return minutos * 60 * 1000;
    }
} 